<template>
<div class="center">
  <div class="box w-mob my-3" style="top:20vh;">
    <h1 class="title is-3 has-text-centered has-text-grey">{{ $t('PasswordReset.title') }}</h1>
    <form @submit.prevent="passwordResetConfirm">
      <div class="field">
    <p>{{ $t('PasswordReset.checkEmail') }}</p>
    <div class="alert alert-info" v-if="error">
      <p v-if="error" class="error">{{ $t('PasswordReset.error') }}: {{ error.message }}</p>
    </div>
      <div class="control">
        <input type="text" class="input mt-05" :placeholder="$t('PasswordReset.email')" v-model="username" required>
      </div>
      <div class="control">
        <input type="text" class="input mt-05" :placeholder="$t('PasswordReset.secretCode')" v-model="code" required>
      </div>
      <div class="control">
        <input type="password" class="input mt-05" :placeholder="$t('PasswordReset.makeNewPwd')" v-model="pass" required>
      </div>
      <button class="button is-info is-fullwidth mt-1">{{ $t('PasswordReset.saveNewPwd') }}</button>
    </div>
    </form>
  </div>
 </div>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      code: "",
      pass: "",
      error: null
    };
  },
  methods: {
    passwordResetConfirm() {
      this.$cognitoAuth.confirmPassword(
        this.username,
        this.code,
        this.pass,
        (err, result) => {
          if (err) {
            this.error = err;
            console.error(err);
          } else {
            console.log("Signup successful:", result);
            this.$router.replace("/");
          }
        }
      );
    }
  }
};
</script>

<style>
.error {
  color: red;
}
</style>
